import { Check } from "lucide-react";
import { Reveal } from "../components/Reveal";

const VALUES = [
  "Founder-led service",
  "Clear communication",
  "Human judgement, smart tools",
  "Support after launch",
];

const TEAM = [
  {
    name: "Max Sharman",
    role: "Co-Founder",
    image: "/assets/max.jpg",
    bio: "Co-Founder of Harman AI Solutions. Studying Accounting & Finance at the University of Glasgow. Hands-on across the whole process — client communication and pricing as well as design and technical build.",
  },
  {
    name: "Ethan Hamilton",
    role: "Co-Founder",
    image: "/assets/ethan.jpg",
    bio: "Co-Founder of Harman AI Solutions. Studying Business & Computer Science at the University of Aberdeen. Works across every stage, from design and technical build through to client communication and pricing.",
  },
];

export default function AboutPage() {
  return (
    <div className="pt-28 md:pt-32 px-5 md:px-10 pb-10 md:pb-16 space-y-8">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <div className="glass-panel px-6 py-12 md:px-14 md:py-16">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <p className="text-xs font-bold tracking-[0.22em] text-[#39D5FF] mb-4">ABOUT US</p>
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-[#F7FAFF] leading-tight">
                  Two People. One Focus: <span className="text-gradient">Helping Your Business Grow.</span>
                </h1>
                <p className="mt-6 text-base md:text-lg text-[#AEBFD8] leading-relaxed max-w-xl">
                  Harman AI Solutions is a founder-led website studio. You work directly with the people designing and
                  building your website — no agency handoffs, no jargon.
                </p>

                <div className="mt-8 grid sm:grid-cols-2 gap-4">
                  {VALUES.map((v) => (
                    <div key={v} className="flex items-center gap-3 glass-card px-4 py-3.5" data-testid="about-value">
                      <span className="grid place-items-center w-7 h-7 rounded-full bg-[rgba(69,224,181,0.15)] border border-[rgba(69,224,181,0.4)] shrink-0">
                        <Check size={15} className="text-[#45E0B5]" />
                      </span>
                      <span className="text-sm font-semibold text-[#F7FAFF]">{v}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex justify-center">
                <div className="glass-card relative w-full max-w-[420px] aspect-square flex items-center justify-center overflow-hidden">
                  <div className="absolute inset-0" aria-hidden="true">
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-72 h-72 rounded-full bg-[radial-gradient(circle,rgba(0,168,255,0.30),transparent_70%)] blur-2xl" />
                  </div>
                  <img src="/assets/logo.png" alt="Harman AI Solutions emblem"
                    className="relative z-10 w-36 md:w-44 drop-shadow-[0_0_36px_rgba(0,168,255,0.6)]" />
                  <div className="absolute inset-x-8 top-4 h-1/3 rounded-[14px] bg-gradient-to-b from-white/10 to-transparent pointer-events-none" aria-hidden="true" />
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>

      {/* Meet the Team */}
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <div className="glass-panel px-6 py-12 md:px-14 md:py-16">
            <div className="text-center max-w-2xl mx-auto mb-10">
              <p className="text-xs font-bold tracking-[0.22em] text-[#39D5FF] mb-4">MEET THE TEAM</p>
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#F7FAFF]">
                The People <span className="text-gradient">Behind the Work.</span>
              </h2>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
              {TEAM.map((m, i) => (
                <Reveal key={m.name} delay={i * 0.1}>
                  <div className="glass-card p-6 flex items-start gap-5 h-full" data-testid="team-member">
                    {m.image ? (
                      <img src={m.image} alt={m.name}
                        className="w-20 h-20 shrink-0 rounded-2xl object-cover border border-[rgba(65,176,255,0.5)] shadow-[0_0_24px_rgba(0,168,255,0.3)]" />
                    ) : (
                      <div className="grid place-items-center w-20 h-20 shrink-0 rounded-2xl bg-gradient-to-br from-[#087CFF] to-[#1745FF] text-white text-2xl font-extrabold shadow-[0_0_24px_rgba(0,168,255,0.35)]">
                        {m.initials}
                      </div>
                    )}
                    <div>
                      <h3 className="text-xl font-bold text-[#F7FAFF]">{m.name}</h3>
                      <p className="text-sm text-[#39D5FF] font-semibold">{m.role}</p>
                      <p className="mt-2 text-sm text-[#AEBFD8] leading-relaxed">{m.bio}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
